import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const ConfirmDialog = ({ open, onCancel, onConfirm, title, children, confirmLabel = "Elimina", confirmClass = "bg-[#e30613] hover:bg-[#c00510]" }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent className="max-w-[420px]">
      <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
      <DialogDescription className="text-[14px] text-gray-600">{children}</DialogDescription>
      <DialogFooter>
        <button onClick={onCancel} data-testid="confirm-dialog-cancel" className="px-4 py-2 text-[13px] font-semibold text-gray-600 hover:bg-gray-100 rounded-sm transition-colors">Annulla</button>
        <button onClick={onConfirm} data-testid="confirm-dialog-confirm" className={`px-4 py-2 text-[13px] font-bold text-white ${confirmClass} rounded-sm transition-colors`}>{confirmLabel}</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
